import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";   //  npm i react-icons

/*──────────────────────────  DATA  ──────────────────────────*/
const faqData = [
  {
    q: "What languages do you support?",
    a: "We support over 50 languages including Hindi, Marathi, German, Hindi, Gujarati, and more.",
  },
  {
    q: "What is your translation process?",
    a: "Our workflow includes: Analysis, Translation, Quality Review, and Delivery—ensuring accuracy and clarity.",
  },
  {
    q: "Do you offer certified translations?",
    a: "Yes, we provide certified translations for legal, medical, and official documents.",
  },
];

/*──────────────────────────  THEME  ─────────────────────────*/
const C = {
  dark: "#1f2429",              // header bar + icon colour
  white: "#ffffff",
  grayText: "#6f6f6f",          // body text colour
  radiusPill: "50px",
  radiusCard: "10px",
  fontFamily: `"Rajdhani", "Teko", sans-serif`,
};

export default function FaqSection() {
  const [open, setOpen] = useState(0);            // first panel open

  return (
    <div style={{ maxWidth: 850 }}>
      {faqData.map(({ q, a }, i) => {
        const active = open === i;

        /*──────────────── HEADER (question row) ────────────────*/
        const header = {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          padding: "12px 40px",
          background: active ? C.dark : C.white,
          color: active ? C.white : C.dark,
          borderRadius: active
            ? `${C.radiusCard} ${C.radiusCard} 0 0`
            : C.radiusPill,
          fontFamily: C.fontFamily,
          fontWeight: 500,
          fontSize: 20,
          letterSpacing: 0.3,
          lineHeight: 1.1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        };

        /* plus / minus badge */
        const iconWrap = {
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: `2px solid ${active ? C.white : C.dark}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        };

        /*──────────────── BODY (answer text) ───────────────────*/
        const body = {
          display: active ? "block" : "none",
          background: C.white,
          borderRadius: `0 0 ${C.radiusPill} ${C.radiusPill}`,
          padding: "35px 45px",
          color: C.grayText,
          fontSize: 16,
          lineHeight: 1.6,
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        };

        return (
          <div key={i} style={{ marginBottom: 37 }}>
            <div style={header} onClick={() => setOpen(active ? -1 : i)}>
              {q}
              <span style={iconWrap}>
                {active ? (
                  <FaMinus size={14} color={active ? C.white : C.dark} />
                ) : (
                  <FaPlus size={14} color={active ? C.white : C.dark} />
                )}
              </span>
            </div>

            <div style={body}>{a}</div>
          </div>
        );
      })}
    </div>
  );
}
